import { Component, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface IRaffleEditResult {
  count: number;
  reason: string;
}

@Component({
  selector: 'app-raffle-edit-dialog',
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content [formGroup]="form">
      <p>{{ data.description }}</p>
      <mat-form-field *ngIf="data.count != null" appearance="outline">
        <mat-label>Вес условия (conditions count)</mat-label>
        <input
          matInput
          type="number"
          min="1"
          step="1"
          formControlName="count"
        />
        <mat-error>Введите положительное целое число</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Причина изменения</mat-label>
        <textarea
          matInput
          formControlName="reason"
          maxlength="1000"
          rows="3"
        ></textarea>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Отмена</button>
      <button
        mat-raised-button
        color="warn"
        [disabled]="form.invalid || !form.value.reason?.trim()"
        [mat-dialog-close]="result"
      >
        Подтвердить
      </button>
    </mat-dialog-actions>
  `,
})
export class RaffleEditDialogComponent {
  get result(): IRaffleEditResult {
    return {
      count: this.form.controls.count.value ?? 1,
      reason: this.form.controls.reason.value?.trim() ?? '',
    };
  }
  readonly form = this.fb.group({
    count: [
      this.data.count ?? 1,
      [
        Validators.required,
        Validators.min(1),
        Validators.pattern(/^[1-9]\d*$/),
      ],
    ],
    reason: ['', [Validators.required, Validators.maxLength(1000)]],
  });
  constructor(
    private readonly fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
    public readonly data: {
      title: string;
      description: string;
      count?: number;
    },
  ) {}
}
